import React, { useState, useCallback, Fragment, useEffect } from 'react';
import {Button, Box, Grid, Paper, CircularProgress, TextField, Typography, Divider} from '@mui/material';
import client from '../common/client';
import {JSONTree} from 'react-json-tree'
import { useParams } from 'react-router-dom';

const BlockCloudJsonView = props => {
    const params = useParams()
    const [loading, setLoading] = useState(false);
    const [cloudJson, setCloudJson] = useState({});

    useEffect(() => {
        setLoading(true)
        // console.log(props)
        client.request_get(`/block/${params.id}`).then(res=>{
            setLoading(false)
            // console.log(res.cloud_json)
            setCloudJson(res.cloud_json)
        }).catch(e=>{
        })
    },[props.block_id])

    return (
        <Fragment>
            <div>{loading && <CircularProgress size={20} />}</div>
            <div>
                <JSONTree data={cloudJson} shouldExpandNode={(keyPath, data, level)=>true}/>
            </div>
        </Fragment>
    );
};

export default BlockCloudJsonView;
